{
  "nav": {
    "label": "Main menu",
    "reservoirs": "Reservoirs",
    "noTenants": "No reservoirs available",
    "organizations": "Organizations",
    "settings": "Settings",
    "interfaceSettings": "Interface settings",
    "hotkeys": "Keyboard shortcuts",
    "guide": "User guide",
    "collapse": "Collapse menu",
    "expand": "Expand menu",
    "expandItem": "Expand {{name}}",
    "collapseItem": "Collapse {{name}}",
    "groups": {
      "devices": "Device management",
      "monitoring": "Monitoring",
      "employees": "Employees",
      "connectors": "Connectors",
      "documents": "Documents",
      "alarms": "Safety criteria",
      "constructor": "Constructor"
    },
    "items": {
      "deviceConfig": "Device configuration",
      "deviceCategories": "Device categories",
      "deviceLocations": "Device locations",
      "deviceInfo": "Device information",
      "deviceCalibration": "Device calibration",
      "charts": "Chart management",
      "monitoringDevices": "Device data",
      "monitoringPhysical": "Physical indicators",
      "monitoringVirtual": "Virtual indicators",
      "employees": "Employee management",
      "connectors": "Connector management",
      "documents": "Documents",
      "alarms": "Criteria monitoring",
      "dashboard": "Dashboard"
    }
  },
  "tabs": {
    "label": "Open pages",
    "home": "Dashboard",
    "dashboardEdit": "Dashboard editor",
    "sectionEdit": "Section editor",
    "section": "Section",
    "devices": "Device configuration",
    "charts": "Chart management",
    "monitoring": "Data monitoring",
    "employees": "Employee management",
    "connectors": "Connector management",
    "documents": "Documents",
    "alarms": "Criteria monitoring",
    "settings": "Settings",
    "guide": "User guide",
    "admin": "Organizations",
    "pin": "Pin",
    "unpin": "Unpin",
    "close": "Close",
    "unsaved": "Unsaved changes",
    "scrollLeft": "Previous tabs",
    "scrollRight": "Next tabs",
    "confirmClose": {
      "title": "Unsaved changes",
      "text": "Closing “{{title}}” discards the changes you made.",
      "stay": "Stay",
      "close": "Close"
    }
  },
  "pages": {
    "dashboardEdit": "Dashboard editor",
    "sectionEdit": "Section editor",
    "deviceConfig": "Device configuration",
    "deviceCategories": "Device categories",
    "deviceLocations": "Device locations",
    "deviceInfo": "Device information",
    "deviceCalibration": "Device calibration",
    "charts": "Chart management",
    "monitoringDevices": "Device data",
    "monitoringPhysical": "Physical indicator monitoring",
    "monitoringVirtual": "Virtual indicator monitoring",
    "employees": "Employee management",
    "connectors": "Connector management",
    "documents": "Documents",
    "alarms": "Criteria monitoring",
    "settings": "Settings",
    "interfaceSettings": "Interface settings",
    "hotkeys": "Keyboard shortcuts",
    "guide": "User guide",
    "admin": "Organizations and reservoirs"
  },
  "comingSoon": {
    "hint": "This page is under construction and will be available soon."
  },
  "noAccess": {
    "title": "No access",
    "hint": "You don't have permission to view this page. Contact your administrator."
  },
  "user": {
    "menu": "User menu",
    "settings": "Settings",
    "logout": "Sign out",
    "roles": {
      "platform_admin": "Main admin",
      "org_admin": "Organization admin",
      "tenant_admin": "Reservoir admin",
      "tenant_member": "Employee"
    }
  }
}
